var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"text-center",attrs:{"cols":"12","md":"6"}},[_c('div',{ref:"lottie",staticClass:"lottie",attrs:{"data-bm-renderer":"svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }